(function () {
  let running = false;

  function updateSaleBadges() {
    if (running) return;
    running = true;
    requestAnimationFrame(() => {
      document.querySelectorAll('.price--on-sale').forEach(priceContainer => {
        const priceBlock = priceContainer.querySelector('.price__sale');
        if (!priceBlock) return;
        const saleEl = priceBlock.querySelector('.price-item--sale');
        const compareEl = priceBlock.querySelector('s.price-item--regular');
        if (!saleEl || !compareEl) return;

        const sale = parseInt(priceContainer.getAttribute('data-price'));
        const compare = parseInt(priceContainer.getAttribute('data-compare'));

        if (!sale || !compare || compare <= sale) return;

        const discountPercent = Math.round(((compare - sale) * 100) / compare);

        let badge = priceBlock.querySelector('.sale_badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'sale_badge';
          saleEl.appendChild(badge);
        }
        badge.textContent = `Du sparst ${discountPercent}%`;
      });
      running = false;
    });
  }

  document.addEventListener('DOMContentLoaded', updateSaleBadges);
  const observer = new MutationObserver(updateSaleBadges);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();